module.exports = __webpack_public_path__ + "img/start.1780bc3c.png";